import React, { lazy, Suspense } from "react";
import { CircleLoaderIcon } from "@smartsuite/react-ui/lib/components/loaders/CircleLoaderIcon/CircleLoaderIcon";
// eslint-disable-next-line
const UiwCodeMirror = lazy(() => import("@uiw/react-codemirror"));
export const CodeMirror = (props) => (React.createElement(Suspense, { fallback: React.createElement(CircleLoaderIcon, null) },
    React.createElement(UiwCodeMirror, { ...props })));
